<div class="row">
    <div class="col-md-12 col-sm-12">
        <h4>Use of LawShelf Information</h4>
        <p>LawShelf is provided to the public on an “as is” basis. LawShelf does not guarantee the accuracy of its content and user utilize LawShelf information at their sole risk. This includes the content of all videos and text on this site including the information presented in all digital badge and certificate programs. By using LawShelf, you agree that your use of the site is at your own risk and you agree, to the maximum extent permitted by law, to hold LawShelf and all of its providers, vendors, successors and assigns harmless from all possible damages whatsoever. LawShelf expressly disclaims any and all warranties, express or implied, regarding its content. The user agrees to indemnify, defend and hold LawShelf and its officers, directors, employees, affiliates, agents, licensors and suppliers harmless from and against all claims, losses, expenses, damages and costs, including reasonable legal fees, resulting from any violation of its terms.</p>
    </div>
</div>
<hr>
<div class="row">
    <div class="col-md-12 col-sm-12">
        <h4>Republication</h4>
        <p>Users are welcome to post links to LawShelf content, including pages, articles and presentations. Users may not reproduce or republish content from LawShelf without the express written consent of a LawShelf representative. Anyone wishing to request permission to republish or reproduce any content should <a [routerLink]="['/contactusview']">contact us</a>.</p>
    </div>
</div>
<hr>
<div class="row">
    <div class="col-md-12 col-sm-12">
        <h4>Links</h4>
        <p>The LawShelf home page or any subpage may be linked to from another webpage, so long as the content or information on any LawShelf page is not taken out of context or in any way misrepresented. Moreover, LawShelf reserves the right to request that any links to any LawShelf website be removed from any website. By linking to any LawShelf page, you agree to remove such link upon request by LawShelf.</p>
    </div>
</div>
<hr>
<div class="row">
    <div class="col-md-12 col-sm-12">
        <h4>Cancellation</h4>
        <p>Users may cancel their subscriptions at any time.</p>
    </div>
</div>
<hr>
<div class="row">
    <div class="col-md-12 col-sm-12">
        <h4>Termination</h4>
        <p>LawShelf may, in its sole discretion and for any reason, terminate any person’s access to LawShelf if the user’s conduct is found to be unlawful, inconsistent with or in violation of, the letter or spirit of these Terms. LawShelf shall not be liable to you or any third party for termination of website access.</p>
    </div>
</div>
<hr>
<div class="row">
    <div class="col-md-12 col-sm-12">
        <h4>Governing Law and Jurisdiction</h4>
        <p>These Terms are governed by and construed in accordance with the laws of the State of Arizona, and you agree to submit to the exclusive jurisdiction of the state and federal courts sitting in Arizona. You agree to waive all defenses or objections to such jurisdiction and venue.</p>
    </div>
</div>
<hr>
<div class="row">
    <div class="col-md-12 col-sm-12">
        <h4>Severability of Provisions</h4>
        <p>If any provision of these Terms is unlawful, void or unenforceable, then that provision shall be deemed severable from the remaining provisions and shall not affect their validity and enforceability.</p>
    </div>
</div>
<hr>
<div class="row">
    <div class="col-md-12 col-sm-12">
        <h4>Contact Information</h4>
        <p>If you have any questions about these Terms, or about the content, information or services on this website, you may contact us via our contact us page.</p>
    </div>
</div>